var events = {};
export var PubSub = {
    publish: function publish(event) {
        if (!events.hasOwnProperty(event)) {
            return false;
        }
        return !!events[event].map(function(callback) {
            return callback();
        });
    },
    subscribe: function subscribe(event, callback) {
        if (!events.hasOwnProperty(event)) {
            events[event] = [];
        }
        return events[event].push(callback);
    },
    unsubscribe: function unsubscribe(event, callback) {
        if (!events.hasOwnProperty(event)) {
            return false;
        }
        var index = events[event].indexOf(callback);
        if (index === -1) {
            return false;
        }
        events[event].splice(index, 1);
        return true;
    }
};

//# sourceMappingURL=PubSub.js.map